export const APPROVAL_LIST = "APPROVAL_LIST";
export const ACCEPT = "ACCEPT";
export const REJECT = "REJECT";